import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Icon, Typography } from "antd";

import compose from 'recompose/compose';
import PropTypes from 'prop-types';

import { withStyles, withWidth } from '@material-ui/core';
import * as AllIcons from '.';


const { Title } = Typography;

const { Meta } = Card;
const styles = theme => ({
    title: {
        color: 'red'
    },
    svgContainer: {
        background: 'gray',
        width: '200px',
        height: '200px'
    },
    scalingSvgContainer: {
        width: '30px',
        height: '30px',
    },
    scalingSvg: {
        width: '100%',
        height: '100%'
    },
    centeredContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#E9ECEF '
    }
});
class Icons extends Component {


    render() {
        const { classes } = this.props;

        const listIcons = Object.keys(AllIcons);
        return (
            <div style={{ margin: '20px', overflow: 'auto' }}>
                <Title>Icons Gohub</Title>
                <Row gutter={16} align='middle' style={{ marginTop: '10px' }}>
                    {listIcons.map((name, index) => {
                        const Component = AllIcons[name];
                        return <Col key={index} span={4} style={{ marginTop: '10px' }}>
                            <Card className={`cardIconsHub ${classes.centeredContent}`}>
                                <div className='contentIcon' >
                                    <Icon className='iconHub' component={Component} key={`${index}-${name}`} height={24} width={24} ></Icon>
                                </div>
                                <Meta title={name} style={{ marginTop: '20px', fontSize: '10px' }} />
                            </Card>
                        </Col>;
                    })}
                </Row>
            </div >
        );
    };
}
Icons.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    width: PropTypes.string.isRequired
};
export default compose(withStyles(styles), withWidth())(Icons);